.placeHolderWrapper {
  img, .shimmer-image {
    cursor: pointer;
  }
  .imageWrapper {
    .shimmer-image,
    img,
    svg {
      box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.07);
      margin: auto;
      max-height: 826px;
      max-width: 500px;
    }
    .shimmer-image svg {
      height: 100% !important;
      width: auto !important;
    }
  }

  .tileImageWrapper {
    .shimmer-image,
    svg,
    img {
      width: 180px !important;
    }
  }
}

@media screen and (max-height: 1100px) {
  .placeHolderWrapper {
    .imageWrapper {
      .shimmer-image,
      img,
      svg {
        /**
         * max height of issue image will be adjusted by subtracting other component height from window height
         * other components are header, date and day, button, etc excluding multi-title
         */
        max-height: calc(100vh - 225px);
      }

      .mutilTitleIssue {
        &,
        svg {
          /**
           * max height of issue image will be adjusted by subtracting other component height from window height
           * other components are header date and day, multi-title, button, etc 
           */
          max-height: calc(100vh - 270px);
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .placeHolderWrapper {
    .imageWrapper {
      margin: 0 34px;

      .shimmer-image,
      img,
      svg {
        height: initial;
        max-height: 65vh;
        max-width: 100%;
      }

      .mutilTitleIssue {
        &,
        svg {
          max-height: 60vh;
          max-width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 410px) {
  .placeHolderWrapper {
    .imageWrapper {
      margin: 0 25px;
    }
  }
}
